import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DriverCreatedSucessComponent } from '../driver/driver-created-sucess/driver-created-sucess.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EMAIL_VALIDATION_PATTERN, MULTILINGUAL_NAME_VALIDATION_PATTERN } from '@shared/constant/shared.constant';
import { CompanyService, BreadcrumbItem } from '@shared/services/company.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { PhoneNumberFormat, SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
import { SuperAdminService } from '@core/services/super-admin.service';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-role-based-user-creation',
  templateUrl: './role-based-user-creation.component.html',
  styleUrls: ['./role-based-user-creation.component.scss']
})
export class RoleBasedUserCreationComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  createDriverForm: FormGroup;
  nationalNumber: PhoneNumberFormat;
  searchCountryField = SearchCountryField;
  countryISO: CountryISO = CountryISO.UnitedStates;
  phoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  separateDialCode = false;
  NAME_MAX_LENGTH: number = 50;

  constructor(
    private readonly dialogControlService: DialogControlService,
    private readonly superAdminService: SuperAdminService,
    private readonly fb: FormBuilder,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
  ) {

    this.createDriverForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(this.NAME_MAX_LENGTH),  CommonFunctions.noLeadingSpacesValidator()]],
      lastName: ['', [Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(this.NAME_MAX_LENGTH), CommonFunctions.noLeadingSpacesValidator()]],
      email: ['', [Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
      phone: [''],
    });
  }

ngOnInit() {
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Manage Users',
      },
      {
        title: 'Create Driver',
      }
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
  }

  createDriverBySuperAdmin() {
    if (this.createDriverForm.invalid) {
      this.createDriverForm.markAllAsTouched();
    }

    if (this.createDriverForm.valid) {
      
      const updateRequest = {
        driverName: this.createDriverForm.value.firstName,
        lastName: this.createDriverForm.value.lastName,
        email: this.createDriverForm.value.email,
        mobileNumber: this.createDriverForm.value?.phone?.number,
        iso: this.createDriverForm.value?.phone?.countryCode,
        countryCode: this.createDriverForm.value?.phone?.dialCode,
      }
      this.superAdminService.CreateDriverBySuperAdmin(updateRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          this.openSuccessModal(res.message)
        }, error: (error) => {
          this.toastService.showToastMessage('error', 'Error', error.error.message)
        }
      })
    }

}

  openSuccessModal(message) {
    this.dialogControlService.openDialog(DriverCreatedSucessComponent, {
      data: {
        successMessage: message
      },
      width: '30%',
    });
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key >= '0' && event.key <= '9') {
      event.preventDefault();
    }
  }

}
